import {
  distributionGetData,
  distributionInputData,
  distributionUpdate,
  distributionWayOutput
} from '@/api/api'

const state = {
  distributionList: []
}

const getters = {
  distributionList: state => state.distributionList
}

let statusTextMap = {
  way: '在途',
  plan: '计划',
  end: '入库'
}

const actions = {
  loadDistributionList ({ dispatch }, parm) {
    return distributionGetData(parm).then((data) => {
      data.forEach((item) => {
        item.planTimeA = item.planTime
        item.planTime = item.planTime.slice(5, 10)
        item.planVolume = parseInt(item.planVolume)
        item.sendTimeA = item.sendTime
        item.sendTime = item.sendTime ? item.sendTime.slice(5, 16) : ''
        item.inTimeA = item.inTime
        item.inTime = item.inTime ? item.inTime.slice(5, 16) : ''
        item.statusText = statusTextMap[item.status]
        item.oilNameS = item.oilName.split('号')[0] + '#'
        item.checkText = item.isCheck ? '已核对' : null
      })
      dispatch('setDistributionList', data)
    })
  },
  distributionWayOutput ({ dispatch }, parm) {
    return distributionWayOutput(parm)
  },
  distributionUpdate ({ dispatch }, parm) {
    return distributionUpdate(parm)
  },
  distributionInputData ({ dispatch }, parm) {
    return distributionInputData(parm)
  },
  setDistributionList ({ commit }, data) {
    commit('setDistributionList', data)
  }
}

const mutations = {
  setDistributionList (state, data) {
    state.distributionList = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/distribution.js